import React, { useState, useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";

const HERO_VIDEO = "https://customer-assets.emergentagent.com/job_1e4446e1-36f0-48d6-b8d8-c196b23a6c28/artifacts/r6xve12v_video%20sezione%201.mp4";

const VIDI_LOGO = "https://customer-assets.emergentagent.com/job_brand-identity-dev-2/artifacts/fkw9y91b_logo%20vidi%20communication.png";

const Header = () => {
  const { t, lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    const onKeyDown = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("scroll", onScroll);
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const headerEl = document.querySelector("header");
      const headerH = headerEl ? headerEl.offsetHeight : 100;
      const offset = el.getBoundingClientRect().top + window.scrollY - headerH - 16;
      window.scrollTo({ top: offset, behavior: "smooth" });
    }
    setOpen(false);
  };

  const navItems = [
    { label: t.nav.strategy, id: "strategy" },
    { label: t.nav.contentCreation, id: "content-creation" },
    { label: t.nav.campaigns, id: "campaigns" },
    { label: t.nav.webAutomation, id: "web-automation" },
    { label: t.nav.contacts, id: "contact" },
  ];

  return (
    <>
      <header
        data-testid="main-header"
        style={{
          position: "fixed",
          top: 0, left: 0, right: 0, zIndex: 1000,
          background: "#fff",
          borderBottom: scrolled ? "1px solid #eee" : "1px solid transparent",
          boxShadow: scrolled ? "0 2px 20px rgba(0,0,0,0.06)" : "none",
          transition: "border-color 0.3s ease, box-shadow 0.3s ease",
          padding: "0 32px",
          height: "100px",
          display: "flex", alignItems: "center", justifyContent: "space-between",
        }}
      >
        {/* Real Logo — full image, no text */}
        <a href="#" data-testid="logo" style={{ textDecoration: "none", display: "flex", alignItems: "center" }}
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}>
          <img
            src={VIDI_LOGO}
            alt="ViDi Communications"
            style={{
              height: "68px",
              width: "68px",
              objectFit: "contain",
              borderRadius: "12px",
              backgroundColor: "transparent",
            }}
          />
        </a>

        {/* Hamburger */}
        <button
          data-testid="hamburger-btn"
          onClick={() => setOpen(true)}
          style={{
            background: "none", border: "none", cursor: "pointer",
            padding: "8px", color: "#333",
            display: "flex", alignItems: "center", gap: "8px",
          }}
        >
          <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: "12px", color: "#888", letterSpacing: "0.1em", textTransform: "uppercase" }}>MENU</span>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <span style={{ display: "block", width: "22px", height: "2px", background: "#333", borderRadius: "2px" }} />
            <span style={{ display: "block", width: "16px", height: "2px", background: "#333", borderRadius: "2px" }} />
            <span style={{ display: "block", width: "22px", height: "2px", background: "#333", borderRadius: "2px" }} />
          </div>
        </button>
      </header>

      {/* Overlay */}
      <div onClick={() => setOpen(false)} style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
        zIndex: 1001, opacity: open ? 1 : 0,
        pointerEvents: open ? "all" : "none",
        transition: "opacity 0.3s ease",
      }} />

      {/* Side panel */}
      <div
        data-testid="nav-panel"
        style={{
          position: "fixed", top: 0, right: 0, bottom: 0, width: "320px",
          background: "#fff", zIndex: 1002,
          transform: open ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          display: "flex", flexDirection: "column", padding: "28px",
          boxShadow: "-4px 0 30px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "40px" }}>
          <img src={VIDI_LOGO} alt="ViDi" style={{ height: "72px", width: "72px", borderRadius: "10px", objectFit: "contain" }} />
          <button onClick={() => setOpen(false)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "22px", color: "#333", padding: "4px", lineHeight: 1 }}>✕</button>
        </div>

        <nav style={{ flex: 1 }}>
          {navItems.map((item, i) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => scrollTo(item.id)}
              style={{
                display: "block", width: "100%", textAlign: "left",
                background: "none", border: "none", cursor: "pointer",
                padding: "13px 0",
                borderBottom: "1px solid #f0f0f0",
                fontFamily: "'Body Grotesque', 'Space Grotesk', sans-serif",
                fontWeight: 700, fontSize: "17px",
                color: "#333", letterSpacing: "-0.3px",
                transition: "color 0.2s ease, padding-left 0.2s ease",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.color = "#ffc84d"; e.currentTarget.style.paddingLeft = "8px"; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = "#333"; e.currentTarget.style.paddingLeft = "0"; }}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div style={{ marginTop: "28px", paddingTop: "20px", borderTop: "1px solid #f0f0f0" }}>
          <p style={{ fontFamily: "'Poppins', sans-serif", fontSize: "10px", color: "#bbb", letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "12px" }}>Language</p>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {["en", "it", "es"].map((l) => (
              <button
                key={l}
                data-testid={`lang-${l}`}
                onClick={() => setLang(l)}
                style={{
                  padding: "7px 18px",
                  borderRadius: "50px",
                  border: "1.5px solid",
                  borderColor: lang === l ? "#ffc84d" : "#e0e0e0",
                  background: lang === l ? "#ffc84d" : "transparent",
                  color: lang === l ? "#333" : "#777",
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: "11px", fontWeight: 600,
                  cursor: "pointer",
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                  transition: "all 0.2s ease",
                }}
              >
                {l}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
